export const config = {
  title: "Fast And Fair Doors",
  meta: {
    description:
      "Fast And Fair Doors offers professional door installation, repair, and maintenance services in Leander, TX. We specialize in residential and commercial doors, including garage, entry, and interior doors.",
    keywords: [
      "Leander door installation",
      "commercial door repair Leander",
      "garage door service TX",
      "Fast And Fair Doors",
      "professional door maintenance"
    ],
    author: "Fast And Fair Doors",
    canonicalUrl: "https://fastandfairdoorservices.com/"
  },
  sections: {
    header: { businessName: "Fast And Fair Doors" },
    sectionB: {
      heroTitle: "Fast And Fair Doors",
      heroSubtitle: "Expert Door Services in Leander, TX",
      learnAboutText: "Get Your Quote",
      phoneNumber: "5124178933",
      phoneLabel: "(512) 417‑8933",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/1318896654/photo/fixing-at-home-hobby.jpg?s=612x612&w=0&k=20&c=En_My6AamEAe0L7ixFJX19GUFzYAusfynJ6VpVpwXR8=",
      cardData: [
        {
          title: "Residential Doors",
          description: "Entry, interior, patio, and storm door installation."
        },
        {
          title: "Commercial Doors",
          description: "Automatic door systems, security doors, and business-grade hardware."
        },
        {
          title: "Door Repair & Maintenance",
          description: "Garage doors, hinges, locks, hydraulic systems, service plans."
        }
      ],
      description:
        "Fast And Fair Doors delivers high-quality installation, repair, and maintenance for residential and commercial doors in Leander—specializing in garage, entry, patio, and storm door systems with transparent pricing and reliable service."
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "From door installation to routine maintenance, we cover all aspects of door systems.",
      cards: [
        {
          title: "Door Installation",
          description: "New entry, patio, and interior door replacements.",
          imageSrc: "https://media.istockphoto.com/id/157373548/photo/home-improvements-replacing-door-knob.jpg?s=612x612&w=0&k=20&c=nWEnOgL17JakToCOMXOVWrIjEdaQm99mmCSBi5sncKk=",
          imageAlt: "Door Installation"
        },
        {
          title: "Garage Door Services",
          description: "Spring & opener repairs, cable replacement, bracket adjustments.",
          imageSrc: "https://media.istockphoto.com/id/2154413268/photo/repair-man-repair-garage-door.jpg?s=612x612&w=0&k=20&c=WXJIGTBcmdfso4vPM5VLOZLWpSps9B6B-S1b9dgU62o=",
          imageAlt: "Garage Door Repair"
        },
        {
          title: "Commercial Door Work",
          description: "Automatic doors, safety checks, hardware upgrades.",
          imageSrc: "https://media.istockphoto.com/id/2098078955/photo/construction-worker-repairing-the-sliding-window-open-cap-of-adjust-rail-wheel.jpg?s=612x612&w=0&k=20&c=64yv2Fy8w8CxLhO4goQPwrum6ZYIBC1o4wuWeBQqCIY=",
          imageAlt: "Commercial Doors"
        }
      ],
      otherServicesTitle: "Additional Offerings",
      otherServicesList: [
        "Security & Storm Door Repair",
        "Door Hardware Replacement",
        "Preventive Maintenance Plans",
        "Emergency Service Calls"
      ]
    },
    sectionD: {
      aboutTitle: "About Us",
      aboutImage: {
        src: "https://fastandfairdoorservices.com/wp-content/uploads/2025/06/o-3-e1751567796526.jpg",
        alt: "Fast And Fair Doors Team"
      },
      aboutText: [
        "Fast And Fair Doors is locally owned and operated in Leander, TX, committed to honest pricing and long-term customer satisfaction.",
        "Our team has over 15 years of experience with all door types—residential or commercial—providing fast, affordable, and professional service."
      ]
    },
    sectionE: {
      profileImage: null,
      profileAlt: "Fast And Fair Doors Logo",
      businessName: "Fast And Fair Doors",
      contact: {
        phone: "5124178933",
        phoneLabel: "(512) 417‑8933",
        email: "fastandfairdoors@gmail.com",
        website: "https://fastandfairdoorservices.com/",
        address: "Leander, TX, USA"
      },
      socialMedia: {
        facebook: null,
        instagram: null,
        twitter: null,
        linkedin: null,
        youtube: null
      }
    },
    sectionF: {
      address: "Leander, TX, USA",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3777.123456!2d-97.924508!3d30.548660!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8644cd2ec2b3f5dd%3A0xabcdef1234567890!2sLeander%2C%20TX!5e0!3m2!1sen!2sus!4v1718840000000!5m2!1sen!2sus"
    }
  }
};

export default config;
